<template>
    <main style="display: block;">
      <div class="scrollV" >
        <div style="padding: 1rem;" class="newFl">
            <transition name="view" appear>
                <div class="rowrapper">
                    <div class="div1">
                        <p style="font-size: .8rem; font-weight: 600; padding-left: 1rem;">Balance:</p>
                        <h2 style="font-size: 1.8rem; font-weight: 600; color: #2ECC71;" class="balH">
                            <sup>₦</sup>
                            {{ Intl.NumberFormat().format(balance.substring(0, balance.indexOf("."))) }}
                            <sub>.{{ balance.split('.')[1] }}</sub>
                        </h2>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Transfer to</h3>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Your Bank</h3>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Account</h3>
                    </div>
                    <div class="div2" style="backgound: #000000;" v-if="!isLoading">
                      <div style="display: flex; flex-flow: row wrap; justify-content: flex-end; align-content: right; text-align: right; margin-bottom: 1rem;">
                        <form @submit.prevent="getBanks" v-if="bvn != 'None****' && bank_details.account_name == null && !new_bank">
                          <Button class="px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light inline-flex" rounded
                          style="display: flex; justify-content: center; align-items: center;">
                            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                            <span style="text-align: center; font-weight: 600;">Add Bank Account</span>
                          </Button> 
                        </form>
                        <form @submit.prevent="goToStash" v-if="bvn == 'None****'">
                          <Button class="px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light inline-flex" rounded
                          style="display: flex; justify-content: center; align-items: center;">
                            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                            <span style="text-align: center; font-weight: 600;">Add BVN</span>
                          </Button> 
                        </form>
                      </div>
                      <form @submit.prevent="checkSign" class="page9" style="margin-bottom: 1rem;" v-if="bvn != 'None****' && bank_details.account_name != null">

                          <div style="display: flex; flex-flow: row;">
                            <p style="padding-top: .2rem">Account Name: </p>
                            <h4 style="margin-left: .5rem;"> {{ bank_details.account_name }}</h4>
                          </div>
                          <div style="display: flex; flex-flow: row;">
                            <p style="padding-top: .2rem">Account Number: </p>
                            <h4 style="margin-left: .5rem;"> {{ bank_details.starred_account_num }}</h4>
                          </div>
                          <div style="display: flex; flex-flow: row;">
                            <p style="padding-top: .2rem">Bank: </p>
                            <h4 style="margin-left: .5rem;"> {{ bank_details.bank_full_name }}</h4>
                          </div>

                          <button type="button" @click="getBanks" style="color: #2ECC71; font-weight: 600;">Update Bank Account Details</button>

                          <label class="field field_v1">
                            <input class="field__input" type="number" step=".01" min="1000" placeholder="e.g. 1000" v-model="widthAmount" required>
                            <span class="field__label-wrap">
                              <span class="field__label">Withdrawal Amount</span>
                            </span>
                          </label>

                          <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                          :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                              <span style="text-align: center; font-weight: 600;" v-if="!isLoadingWithdraw">Withdraw</span>
                              <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingWithdraw">
                          </Button>
                          <p>Note: There is a ₦200 charge on each transfer</p>

                      </form>
                      <form @submit.prevent="checkBankDetails" class="page" v-if="bvn != 'None****' && new_bank" >
                          <h2>Add Withdrawal Bank Details</h2>

                          <label class="field field_v1">
                            <input class="field__input" type="tel" placeholder="e.g. 2222222222" v-model="create_bank.account_number" 
                            pattern="[0-9]{10}" required>
                            <span class="field__label-wrap">
                              <span class="field__label">Account Number</span>
                            </span>
                          </label>

                          <div class="loading-animation" style="width: 100%; height: 50px;" v-if="isLoadingBanks">
                            <span style="color: transparent">y</span>
                          </div>

                          <label class="field field_v1" v-if="!isLoadingBanks">
			    <v-select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="create_bank.bank_dd"
                            :options="all_banks" label="bankName" :filterable="true" placeholder="Search...">
                              <!-- <option v-for="(bank, index) in all_banks" :key="index" :value="bank">{{ bank.bankName }}</option> -->
                            </v-select>
                            <span class="field__label-wrap">
                            <span class="field__label">Choose Bank</span>
                            </span>
                          </label>

                          <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                          :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                              <span style="text-align: center; font-weight: 600;" v-if="!isLoadingAddAccount">Proceed</span>
                              <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingAddAccount">
                          </Button>
                      </form>
                    </div>
                    <div class="div2" v-if="isLoading">
                      <div class="loading-animation" style="width: 100%; height: 50px;">
                      <span style="color: transparent">y</span>
                      </div>
                      <div class="loading-animation" style="width: 100%; height: 50px; margin-top: 1rem;">
                      <span style="color: transparent">y</span>
                      </div>
                      <div class="loading-animation" style="width: 100%; height: 50px; margin-top: 1rem;">
                      <span style="color: transparent">y</span>
                      </div>
                      <div class="loading-animation" style="width: 100%; height: 50px; margin-top: 1rem;">
                      <span style="color: transparent">y</span>
                      </div>
                      <div class="loading-animation" style="width: 100%; height: 50px; margin-top: 1rem;">
                      <span style="color: transparent">y</span>
                      </div>
                    </div>
                </div>
            </transition>
        </div>
      </div>
      <modal name="confirmWithdrawModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closeConfirmWithdrawModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete this transfer</h4>
            <form class="page2" @submit.prevent="checkPin">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      
    </main>
</template>

<script> 
  // import axios from "axios";
  import axios from '../../AxiosInstance.js';
  import router from "../../router";
  import Button from "../../components/Button";
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import PincodeInput from 'vue-pincode-input';

  var utc = require('dayjs/plugin/utc')
  var timezone = require('dayjs/plugin/timezone');

  dayjs.extend(utc);
  dayjs.extend(timezone);

  export default {
    name: 'withdraw',
    components: {
      Button,
      PincodeInput
    },
    data() {
      return {
        url: process.env.VUE_APP_BASE_URL,
        nodeurl: process.env.VUE_APP_NODE_URL,
        is_staff: localStorage.getItem("on_business_name") ? true : false,
        balance: localStorage.getItem("balance"),
        bvn: localStorage.getItem("bvn"), 
        token: this.decrypt(localStorage.getItem("token")),
        user_id: this.decrypt(localStorage.getItem("user_id")),
        profile_id: this.decrypt(localStorage.getItem("profile_id")),
        has_signatory: this.decrypt(localStorage.getItem("has_signatory")),
        buttonType: 'submit', 
        isLoading: false,
        signatories: [],
        bank_details: {},
        new_bank: false,
        isLoadingBanks: false,
        isLoadingAddAccount: false,
        isLoadingWithdraw: false,
        create_bank: {},
        all_banks: [],
        widthAmount: null,
        isLoadingConPayWB: false,
        pinCode: '',
      }
    },
    mounted() {
      this.checkLoggedIn();
    },
    created() {
      document.title = "Zinger - Transfer";
      dayjs.extend(relativeTime);
    },
    filters: {
      diffForHumans: (date) => {
        if (!date){
            return null;
        }
        return dayjs.tz(date,"Europe/London").fromNow();
      },
      dateFor: (date) => {
        date = date.substring(0, date.indexOf("."))
        return dayjs(date).format('ddd, MMM D, YYYY h:mm A');
      }
    },
    methods: {
      checkLoggedIn() {
        if(!this.is_staff){
            if (!this.token) {
                router.push({ name: "login", query: { redirect: "/transfer" } });
            }else if(this.decrypt(localStorage.getItem("verified_status")) == 'false'){
                router.push("/verify");
            }else if(localStorage.getItem("is_business") == 'false'){
                if(this.decrypt(localStorage.getItem("reached_limit")) == 'true' && localStorage.getItem("is_upgraded") == 'false'){
                    router.push("/upgrade");
                }
                this.getBankDetails();
                this.getSignatories();
            }else{
                this.getBankDetails();
                this.getSignatories();
            }
        }else{
            router.push("/");
        }
      },
      getSignatories(){
        if(this.has_signatory == 'true'){
          axios.get(this.url + "api/v1/signatories-bus/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.signatories = response.data;
            // console.log(response.data)
          }).catch(err => {
            // console.log(err)
          });
        }
      },
      getBankDetails(){
        if(this.bvn != "None***"){
          this.isLoading = true;
          axios.get(this.url + "api/v1/user-bank-account/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
              // console.log(response.data);
              this.bank_details = response.data[0];
              this.isLoading = false;
          }).catch(err => {
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        }
      },
      getBanks(){
        this.new_bank = true;
        this.isLoadingBanks = true; 
        axios.get(this.nodeurl + "get-banks").then(message => {
          // console.log(message.data);
          if(message.data.message.responseCode == "00"){
            // console.log(message.data);
            this.all_banks = message.data.message.banks;
            this.isLoadingBanks = false;
          }else{
            this.isLoadingBanks = false;
            this.$toast.error('Error.', {duration: 3000, position: "top-right"});
          }
        }).catch(err => {
          // console.log(err);
          this.isLoadingBanks = false;
          this.$toast.error('Error.', {duration: 3000, position: "top-right"});
        })
      },
      checkBankDetails(){
        if(this.create_bank.account_number != null && this.create_bank.account_number != '' && this.create_bank.account_number != ' '
        && this.create_bank.bank_dd != null && this.create_bank.bank_dd != '' && this.create_bank.bank_dd != ' '){
          this.isLoadingAddAccount = true; 
          let info = {
            accountNumber: this.create_bank.account_number,
            beneficiaryBank: this.create_bank.bank_dd.bankCode
          };
          axios.post(this.nodeurl + "check-bank-account", info).then(message => {
            // console.log(message.data);
            if(message.data.message.responseCode == "00"){
              // console.log(message.data);
              this.create_bank.account_name = message.data.message.accountName;
              this.updateBankAccount();
              // this.isLoadingAddAccount = false;
            }else{
              this.isLoadingAddAccount = false;
              this.$toast.error('Invalid Account Number.', {duration: 3000, position: "top-right"});
            }
          }).catch(err => {
            console.log(err);
            this.isLoadingAddAccount = false;
            this.$toast.error('Error.', {duration: 3000, position: "top-right"});
          })
        }else{
          this.$toast.error('Kindly Fill All Fields', {duration: 3000, position: "top-right"});
        }
      },
      updateBankAccount(){
        this.create_bank.id = this.bank_details.id;
        this.create_bank.bank_name = this.create_bank.bank_dd.bankCode;
        this.create_bank.bank_full_name = this.create_bank.bank_dd.bankName;
        
        axios.put(this.url + "api/v1/bank-account/" + this.create_bank.id + "/", this.create_bank,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.isLoadingAddAccount = false;
          this.new_bank = false;
          this.bank_details = response.data;
          this.create_bank = {};
          this.$toast.success('Account Added Successfully', {duration: 3000, position: "top-right"});
        }).catch(err => {
          console.log(err);
          this.isLoadingConPayWB = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      checkSign(){
        if(this.has_signatory == 'false'){
          this.$modal.show('confirmWithdrawModal')
        }else{
          this.signWithdraw();
        }
      },
      signWithdraw(){
        if(parseFloat(this.widthAmount).toFixed(2) >= 1000.00){
          this.isLoadingWithdraw = true;
          let new_trans = {};

          let addedAmt = 200.00;

          let senderDetails = {};
          senderDetails.id = this.profile_id;
          senderDetails.user_id = this.user_id;
          senderDetails.amount = parseFloat(this.widthAmount) + parseFloat(addedAmt);
          senderDetails.amount = senderDetails.amount.toFixed(2);
	  senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let new_transaction = {};
          new_transaction.sender = this.user_id;
	  if(localStorage.getItem("is_business") == 'true'){
            new_transaction.sender_name = localStorage.getItem("business_name");
          }else{
            new_transaction.sender_name = localStorage.getItem("first_name") + ' ' + localStorage.getItem("last_name");
          }
          new_transaction.trans_type = "WITHDRAWAL";
          new_transaction.amount = parseFloat(this.widthAmount).toFixed(2);
          new_transaction.withdraw_bank_account = this.bank_details.starred_account_num;
          new_transaction.bank_name_ben = this.bank_details.bank_full_name;

          let info = {
            beneficiaryAccountName: this.bank_details.account_name,
            transactionAmount: parseFloat(this.widthAmount).toFixed(2),
            beneficiaryAccountNumber: this.bank_details.account_number,
            beneficiaryBank: this.bank_details.bank_name,
	    beneficiaryBankName: this.bank_details.bank_full_name,
            // transactionReference: response2.data.reference
          };

          let receiverDetails = {};
          receiverDetails.id = this.user_id;
          receiverDetails.user_id = this.profile_id;
          receiverDetails.amount = parseFloat(this.widthAmount) + parseFloat(addedAmt);

          new_trans.senderDetails = senderDetails;
          new_trans.new_transaction = new_transaction;
          new_trans.receiverDetails = receiverDetails;
          new_trans.info = info;

          let count = 1;

          let new_app = {};
          new_app.appr_type = "WITHDRAWAL";
          new_app.details = JSON.stringify(new_trans);
          new_app.business = this.user_id;

          axios.post(this.url + "api/v1/create-n-approval/", new_app,
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.signatories.forEach(element => {
              new_app.signatory = element.signatory.id;
              new_app.business = element.business.id;
              new_app.approval = response.data.id;
              axios.post(this.url + "api/v1/create-approval/", new_app,
              { headers: { authorization: "Token " + this.token } }).then(response => {
                if(this.signatories.length == count){
                  this.isLoadingWithdraw = false;
                  router.push("/approvals");
                  this.$toast.info('Withdrawal Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
                }else{
                  count++;
                }
              }).catch(err => {
                this.isLoadingWithdraw = false;
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              });
            });
          }).catch(err => {
            this.isLoadingWithdraw = false;
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        }else{
          this.$toast.error('Minimum withdrawal amount is ₦1000', {duration: 3000, position: "top-right"});
        }
      },
      withdraw(){
        if(parseFloat(this.widthAmount).toFixed(2) >= 1000.00){
          this.isLoadingWithdraw = true;

          let addedAmt = 200.00;

          let senderDetails = {};
          senderDetails.id = this.profile_id;
          senderDetails.user_id = this.user_id;
          senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

          let new_transaction = {};
          new_transaction.sender = this.user_id;
	  if(localStorage.getItem("is_business") == 'true'){
            new_transaction.sender_name = localStorage.getItem("business_name");
          }else{
            new_transaction.sender_name = localStorage.getItem("first_name") + ' ' + localStorage.getItem("last_name");
          }
          new_transaction.trans_type = "WITHDRAWAL";
          new_transaction.withdraw_bank_account = this.bank_details.starred_account_num;

              let info = {
                beneficiaryAccountName: this.bank_details.account_name,
                transactionAmount: parseFloat(this.widthAmount).toFixed(2),
                beneficiaryAccountNumber: this.bank_details.account_number,
                beneficiaryBank: this.bank_details.bank_name,
		beneficiaryBankName: this.bank_details.bank_full_name,
                // transactionReference: response2.data.reference,
                token: this.token,
                senderDetails: senderDetails,
                newTransaction: new_transaction,
              };
              
              axios.post(this.nodeurl + "transfer-to-bank", info).then(message => {
                // console.log(message.data);
                if(message.data.message.responseCode == "00"){
                  // console.log(message.data);
                  this.isLoadingWithdraw = false;
                  this.isLoadingConPayWB = false;
                  this.$toast.success('Transfer Successful.', {duration: 3000, position: "top-right"});
                  router.push("/");
                }else{
                  let rn = parseInt(localStorage.getItem('rn')) + 1;
                  let ammmtt = parseFloat(this.widthAmount) + parseFloat(addedAmt);
                  let qrData = {amount: ammmtt, rn: rn};
                  let encData = this.CryptoJS.AES.encrypt(JSON.stringify(qrData), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

                  let receiverDetails = {};
                  receiverDetails.id = this.profile_id;
                  receiverDetails.user_id = this.user_id;
                  receiverDetails.tttdx = encData;

                  // axios.put(this.url + "api/v1/update-receiver-refund-balance/" + receiverDetails.id + "/", receiverDetails,
                  // { headers: { authorization: "Token " + this.token } }).then(response2 => {
                  //   // console.log(response2)
                  //   localStorage.setItem("balance", response2.data.balance);
                  //   this.balance = response2.data.balance;
                  //   this.isLoadingWithdraw = false;
                  //   this.isLoadingConPayWB = false;
                  //   localStorage.setItem('rn', rn);
                  // }).catch(err2 => {
                  // });
                  this.isLoadingWithdraw = false;
                  this.isLoadingConPayWB = false;

                  this.$toast.error('Error Completing Transfer.', {duration: 3000, position: "top-right"});
                }
              }).catch(err => {
                // console.log(err);

                if(err.response){
                  let rn = parseInt(localStorage.getItem('rn')) + 1;
                  localStorage.setItem('rn', rn);
                  this.isLoadingWithdraw = false;
                  this.isLoadingConPayWB = false;
                  if(err.response.data.message.tier){
                    this.$toast.error('Error. Your daily limit has been reached.', {duration: 3000, position: "top-right"});
                  }else{
                    this.$toast.error('Error. Please make sure the bank account is linked to your BVN.', {duration: 3000, position: "top-right"});
                  }
                }else{
                  this.isLoadingWithdraw = false;
                  this.isLoadingConPayWB = false;
                  this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                }

                
              })
        }else{
          this.$toast.error('Minimum withdrawal amount is ₦1000', {duration: 3000, position: "top-right"});
        }
      },
      goToStash(){
        router.push("/stash")
      },
      checkPin(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.withdraw();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      closeConfirmWithdrawModal(){
        this.pinCode = '';
        this.$modal.hide('confirmWithdrawModal');
      },
      zoomUpdated (zoom) {
        this.zoom = zoom;
        this.largeRadius = (this.largeRadius * this.zoom) / this.zoomBase;
        this.smallRadius = (this.smallRadius * this.zoom) / this.zoomBase;
      },
    },
  }
</script>

<style lang="css" scoped>
.scrollV{
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-content: center; */
    height: calc(100vh - 117px);
}

select{
  background: transparent url("data:image/svg+xml;utf8,<svg style='float: right;' width='24' height='24' class='w-6 h-6' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'></path></svg>") no-repeat;
  background-position: right 5px top 50%;
}

.newFl{
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
  scroll-behavior: smooth;
}

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  justify-content: left;
  align-content: left;
  text-align: left;
  /* padding: 0 100px;  */
  padding-top: .7rem;
  /* background: #2ECC71; */
}

.div1 {
  width: 100%;
  flex: 1 1 25rem;
}

.div2 {
  width: 100%;
  flex: 1 1 25rem;
}

h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}
h3 {
  font-size: 3rem;
}

h5 {
  font-size: 1.56rem;
}

@media screen and (max-width: 1024px){
  h3 {
    font-size: 1.98rem;
  }
  h5 {
    font-size: 1.4rem;
  }
}

sup{
  vertical-align: middle;
  font-size: .43em;
  font-weight: 400;
  top: -.62em;
}
sub{
    bottom: .05em;
    margin-left: -4px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0;
    opacity: 1;
    font-size: .4em;
}

.qrClass{
  display: flex;
  align-items: center; 
  flex-direction: column;
  margin: 0 auto;
}

.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
}

.page{
  box-sizing: border-box;
  background: #ffffff; 
  padding: 2rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  /* height: 100%; */
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 30px;
}

.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.page3{
  background: transparent; 
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.page9{
  box-sizing: border-box;
  background: #ffffff; 
  padding: 2rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  /* height: 100%; */
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 10px;
}

.voucherRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.usersRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
  /* flex: 1 1 0rem; */
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  color: #000000;
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  color: #000000;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

@keyframes placeHolderShimmer {
   0% {
    background: #ececec;
  }
  
  30% {
    background: #F7F7F7;
  }
 
  50% {
    background: #ececec;
  }
  
  80% {
    background: #F7F7F7;
  }
  
  100% {
    background: #ececec;
  }
}

.loading-animation {
  animation: placeHolderShimmer 3s infinite;
}

.view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}

.view-enter-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
    transition-delay: 0.2s;
}

.view-enter, .view-leave-to {
    opacity: 0;
}

.view-enter-to, .view-leave {
    opacity: 1;
}

</style>
